<app-custom-carousel appearance="main-slider">
  @for (image of product.images; track image.url) {
    <li app-carousel-item label="">
      <img [ngSrc]="image.url" [alt]="image.alt" fill style="position: static" />
    </li>
  }
</app-custom-carousel>
<app-product-images [images]="product.images"> </app-product-images>
